import { Component } from '@angular/core';

@Component({
  selector: 'app-copyright',
  standalone: false,
  templateUrl: './copyright.component.html',
})
export class CopyrightComponent {
  currentYear: number = new Date().getFullYear();
}
